import {useUniversalFetch} from '#imports';
import type {FreelancerProfile} from '../../../../types/cms-api';

const SEARCH_PROFILES_URL = '/cms/api/search/profiles';

export type SearchProfilesParams = {
    profileIdOrSeoUrl: string[];
    hiddenProfiles?: boolean;
};

export function searchProfiles(params: SearchProfilesParams, baseURL = ''): Promise<FreelancerProfile[]> {
    return useUniversalFetch<FreelancerProfile[]>(SEARCH_PROFILES_URL, {
        query: {
            profileIdOrSeoUrl: params.profileIdOrSeoUrl,
            hiddenProfiles: params.hiddenProfiles ?? false,
        },
        baseURL,
    });
}
